import { useState } from "react";
import {USChangeTab} from "../components/changeManagement/usTabFlow";
import {EUChangeTab} from "../components/changeManagement/euMDRTabFlow";
import { useShallow } from "zustand/react/shallow";
import ContentTitle from "../layout/ContentTitle";



const ChangeManagement = () => {
  const [activeTab, setActiveTab] = useState("fda_change_flow");
  const tabs = [
    {
      id: "fda_change_flow",
      label: "FDAGuideLine",
      content: <USChangeTab />,
      tooltip:
        "Change assessment per FDA guideline",
    },
    {
      id: "eumdr_change_flow",
      label: "EUMDRGuideLine",
      content: <EUChangeTab />,
      tooltip:
        "Change assessment per EUMDR guideline",
    },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="flex h-[calc(100vh-40px)] w-full flex-col overflow-y-hidden">
      <ContentTitle title={"Change Clarity"} />
      
      {/* Tabs */}
      <div className="tabs tabs-boxed mt-4">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`
                tab m-1
                text-sm md:text-base
                tracking-wide
                transition-all duration-300 ease-in-out
                ${
                  isActive
                    ? `
                      tab-active
                      scale-105
                      font-bold
                      bg-base-300
                      text-primary/80
                      border-b-4 border-primary
                      shadow-md
                    `
                    : `
                      font-medium
                      text-base-content
                      opacity-90
                      border border-transparent
                      bg-base-200
                      hover:opacity-100
                      dark:bg-base-300
                    `
                }
              `}
            >
              <span className="tooltip tooltip-bottom flex w-full h-full items-center justify-center" data-tip={tab.tooltip}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>

      {/* Active Tab Content */}
      <div className="card mt-1 flex flex-1 flex-col gap-4 overflow-y-auto p-4 shadow-xl">
        {tabs.find((tab) => tab.id === activeTab)?.content}
      </div>

      {/* <div className="card mt-1 flex h-full w-full flex-col gap-4 overflow-y-auto p-4 shadow-xl">
        {decisionFlow.length === 0 && <ChangeManagementInit />}
        {decisionFlow.length > 0 && <ChangeManagementContent />}
      </div> */}
    </div>
  );
};
export default ChangeManagement;
